import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { push } from "connected-react-router";
import { Button, Modal, ModalBody } from "reactstrap";

const SuccessModal = (props, context) => {
  const dispatch = useDispatch();
  const { success, reset, redirectUrl, resourceType, action, successMessage } =
    props;

  const handleSuccessModalClose = () => {
    dispatch(reset());
    if (redirectUrl) {
      dispatch(push(redirectUrl));
    }
  };

  const getThisResourceTypeString = () => {
    const translations = {
      content_category: context.t("a content category"),
      unlockable_content: context.t("an unlockable content"),
      whitelist_entry: context.t("a whitelist entry"),
      event: context.t("a event"),
      mint: context.t("a token"),
    };
    return translations[resourceType]
      ? translations[resourceType]
      : resourceType;
  };

  const getActionString = () => {
    const translations = {
      created: context.t("created"),
      updated: context.t("updated"),
      minted: context.t("minted"),
    };
    return translations[action] ? translations[action] : resourceType;
  };

  return (
    <Modal
      isOpen={success ? true : false}
      toggle={() => dispatch(reset())}
      centered
      className="border-0 shadow-sm"
    >
      <div className="text-center pt-3">
        <IoMdCheckmarkCircleOutline size={90} color="green" />
      </div>
      <ModalBody className="px-5">
        <div className="mx-auto text-center">
          <h1 className="h2">{context.t("Success!")}</h1>
          <p className="text-muted">
            {action &&
              resourceType &&
              context.t("You successfully {action} {resourceType}", {
                action: getActionString(),
                resourceType: getThisResourceTypeString(),
              })}
            {!!successMessage && successMessage}
          </p>
        </div>
        <div className="text-center">
          <Button
            onClick={handleSuccessModalClose}
            outline
            className="my-3 w-100 text-uppercase"
            color="success"
          >
            {context.t("ok")}
          </Button>
          <small className="text-muted text-center">
            {context.t("click to get back to overview screen")}
          </small>
        </div>
      </ModalBody>
    </Modal>
  );
};

/**  define proptype for the 'translation' function  */
SuccessModal.contextTypes = {
  t: PropTypes.func,
};

SuccessModal.propTypes = {
  success: PropTypes.bool.isRequired,
  reset: PropTypes.func.isRequired,
  redirectUrl: PropTypes.string,
  resourceType: PropTypes.string,
  action: PropTypes.string,
  successMessage: PropTypes.string,
};

export default SuccessModal;
